import type { Column } from '@tanstack/react-table';

function formatCsvCell(value: unknown) {
  let text = String(value ?? '');
  if (/^[=+\-@\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

export function buildVisibleColumnsCsv<TData>(
  rows: TData[],
  visibleColumns: Column<TData, unknown>[],
  formatValue?: (value: unknown, column: Column<TData, unknown>, row: TData) => unknown,
) {
  const exportColumns = visibleColumns.filter(column => column.accessorFn);

  return [
    exportColumns.map(column => formatCsvCell(column.columnDef.meta?.label ?? column.id)),
    ...rows.map((row, rowIndex) =>
      exportColumns.map(column => {
        const value = column.accessorFn?.(row, rowIndex) ?? '';
        return formatCsvCell(formatValue ? formatValue(value, column, row) : value);
      }),
    ),
  ]
    .map(csvRow => csvRow.join(','))
    .join('\n');
}
